import"@cds/core/icon/register.js";import{registerElementSafely as o}from"@cds/core/internal";import{CdsCloseButtonTagName as r,CdsInternalCloseButton as e}from"./close-button.element.js";o(r,e);
